import React, { Component } from "react";
import  Auth  from "@aws-amplify/auth";
import { Consumer } from "../libs/AuthContext";
import { Button, Form, Grid, Header, Divider, Message, Segment, Menu, Label } from "semantic-ui-react";
import "./Login.css";
import { translate } from 'react-i18next';
import i18n from "i18next";
import {languages, languagesFR} from "../libs/utility";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      email: "",
      password: "",
      error: false,
      errorMessage: "",
      confirmation: "",
      newpassword: "",
      action: "Show",
      actionFR: "Afficher",
      type: "password"
    };
  }

  async componentDidMount() {
    const passwordField = document.getElementById("password");
    if (passwordField){
      passwordField.addEventListener( 'keydown', function( event ) {
        let caps = event.getModifierState && event.getModifierState( 'CapsLock' );
        let capsLock = document.getElementById("capsLock");
        if (capsLock) {
          capsLock.style.display = caps ? "block" : "none";
        }
      });
      passwordField.addEventListener( 'keyup', function( event ) {
        let caps = event.getModifierState && event.getModifierState( 'CapsLock' );
        let capsLock = document.getElementById("capsLock");
        if (capsLock) {
          capsLock.style.display = caps ? "block" : "none";
        }
      });
    }
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleShowPassword = event => {
    event.preventDefault();

    this.setState({
      type: this.state.type === "input" ? "password" : "input",
      action: this.state.action === "Show" ? "Hide" : "Show"
    })
  }

  handleShowPasswordFR = event => {
    event.preventDefault();

    this.setState({
      type: this.state.type === "input" ? "password" : "input",
      actionFR: this.state.actionFR === "Afficher" ? "Masquer" : "Afficher"
    })
  }

  handleSubmit = async event => {
    event.preventDefault();
    let email = this.state.email.toLowerCase();
    this.setState({ isLoading: true });

    try {
      await Auth.signIn(email, this.state.password);
      this.props.context.userHasAuthenticated(true);
    } catch (e) {
      console.log(e);
      this.setState({ isLoading: false, error: true, errorMessage: e.message });
    }
  }

  render() {
    const { t } = this.props
    return (
      <main className="Login">
        <Segment textAlign='center' vertical className="topMenuSeg">
          <Menu fixed="top" borderless size="small" as="nav" style={{borderBottomColor: "rgba(34, 36, 38, 0.15", backgroundColor: "#39474F"}}>
            <Menu.Item>
              <a href="/"><img style={{width: "170px", height: "auto"}}src={"/logo-horizontal.png"} alt=""/></a>
            </Menu.Item>
            <Menu.Menu position="right" className="headerComp">
                <Menu.Item >
                  <a href="https://www.bookchain.ca/" style={{color: "#FFFFFF"}}>{t('Homepage')}</a>
                </Menu.Item>
                <Menu.Item >
                  <a href="https://www.bookchain.ca/whatisbookchain" style={{color: "#FFFFFF"}}>{t('What is Bookchain®?')}</a>
                </Menu.Item>
                <Menu.Item>
                  <Form.Dropdown
                    fluid
                    selection
                    options={i18n.language === "en" ? languages : languagesFR}
                    value={i18n.language}
                    onChange={(event,data) => i18n.changeLanguage(data.value)}
                    />
                </Menu.Item>
              </Menu.Menu>
            </Menu>
          </Segment>
          <Grid centered className="loginMain">
            <Grid.Column computer={8} mobile={16}>
              <Segment className="segmentLogin">
                <Header textAlign={"center"} as="h2">{t('Log In')}</Header>
                <p style={{textAlign: "center", paddingBottom: "2em", color: "#39474F"}}>{t('Need a Bookchain® account?')} <a href="/signup">{t('Create an account')}</a></p>
                <Divider hidden />
                <Form error={this.state.error}  onSubmit={this.handleSubmit} className="loginForm">
                  <Form.Input
                    focus
                    id="email"
                    label={t("Email Address")}
                    type="email"
                    defaultValue={this.state.email}
                    onChange={this.handleChange}
                  />
                    { i18n.language !== "fr" &&
                      <Form.Input
                        action={{ content: this.state.action, onClick: this.handleShowPassword, size: "mini" }}
                        id="password"
                        label={t("Password")}
                        value={this.state.password}
                        onChange={this.handleChange}
                        type={this.state.type}
                      />
                    }
                    { i18n.language === "fr" &&
                      <Form.Input
                        action={{ content: this.state.actionFR, onClick: this.handleShowPasswordFR, size: "mini" }}
                        id="password"
                        label={t("Password")}
                        value={this.state.password}
                        onChange={this.handleChange}
                        type={this.state.type}
                      />
                    }
                  <Label basic color='red' pointing id="capsLock" style={{display: "none"}}>
                    {t("Caps Lock is on")}
                  </Label>
                  <Message
                    error
                    header="Ooops!"
                    content={this.state.errorMessage}
                  />
                  <a href="/login/forgotpassword">{t('Forgot your password?')}</a>
                  <Divider hidden />
                  <Button
                    fluid
                    disabled={!this.validateForm()}
                    type="submit"
                    loading={this.state.isLoading}
                  >
                    {t('Login')}
                  </Button>
                </Form>
                </Segment>
              </Grid.Column>
            </Grid>
            <div className="trim" style={{zIndex: "100", maxHeight: "300px"}}>
              <img alt="" width={400} height={400} align='bottom' src={"/copyrightwhite.png"} style={{marginLeft: -170}}/>
            </div>
      </main>
    );
  }
}

export default translate("translations")(props => (
  <Consumer>
    {value => <Login {...props} context={value} />}
  </Consumer>
)
)
